export default __webpack_public_path__ + "static/media/our-city.6c01925d.png";